export default __webpack_public_path__ + "static/media/ALI.c5ee454f.png";